import store from "../store";

export default (to, from, next) => {
  // const selectedPlatform = store.getters["platform/selectedPlatform"];

  try {
    if (to.meta.permission) {
      const userHasPermission = store.getters["auth/hasPermission"];
      if (!userHasPermission(to.meta.permission)) throw new Error();
    }

    next();
  } catch {
    return next({ path: "/" });
  }
};
